import { compact, filter, sortby, values } from '@quromedical/utils';
import type { ContactPoint } from 'fhir/r4';

import { ExtensionUrl } from './extension';

/**
 * Gets any available from a `ContactPoint`
 */
export const getPhone = (telecom: ContactPoint[] = []): string | undefined => {
  const phone = telecom.find((t) => t.system === 'phone' && t.value);

  return phone?.value;
};

export const getHomePhone = (
  telecom: ContactPoint[] = [],
): string | undefined => {
  const phone = telecom.find(
    (t) => t.system === 'phone' && t.value && t.use === 'home',
  );

  return phone?.value;
};

export const getMobilePhone = (
  telecom: ContactPoint[] = [],
): string | undefined => {
  const phone = telecom.find(
    (t) => t.system === 'phone' && t.value && t.use === 'mobile',
  );

  return phone?.value;
};

export const getEmail = (telecom: ContactPoint[] = []): string | undefined => {
  const email = telecom.find((t) => t.system === 'email' && t.value);

  return email?.value;
};

export const getPrimaryPhoneNumber = (telecom: ContactPoint[] = []): string => {
  const phone = telecom
    .filter((t) => t.rank && t.rank === 1 && t.value && t.system === 'phone')
    .map((t) => t.value as string);
  return phone?.[0];
};

export const getSecondaryPhoneNumber = (
  telecom: ContactPoint[] = [],
): string | undefined => {
  const phone = telecom
    .filter((t) => t.rank && t.rank > 1 && t.value)
    .map((t) => t.value as string);
  return phone?.[0];
};

/**
 * Gets all the contact points of a given telecom system sorted by rank
 */
export const getContactValues = (
  system: ContactPoint['system'],
  telecom: ContactPoint[] = [],
): string[] => {
  const telecomWithValues = filter(telecom, (t) => !!t.value);
  const telecomWithSystem = filter(
    telecomWithValues,
    (t) => t.system === system,
  );
  const sortedByRank = sortby(telecomWithSystem, (phone) => phone.rank);
  const phonesNumbers = sortedByRank.map((phone) => phone.value);
  const compacted = compact(phonesNumbers);

  return values(compacted);
};

export const isPrimaryPhoneNumberWhatsAppEnabled = (
  telecom: ContactPoint[] = [],
): boolean => {
  const primaryPhone = telecom.find(
    (t) => t.system === 'phone' && t.rank === 1 && t.value,
  );

  if (!primaryPhone) {
    return false;
  }

  return (
    primaryPhone.extension?.some(
      (ext) =>
        ext.url === ExtensionUrl.whatsappEnabled && ext.valueBoolean === true,
    ) ?? false
  );
};
